import { Modal } from 'antd';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface SuccessModalProps {
  visible: boolean;
  closeModal: () => void;
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
  }
`;

const SuccessModal: FC<SuccessModalProps> = ({ visible, closeModal }) => {
  const { t } = useTranslation();
  const { query } = useRouter();
  const clientName = query.clientName as string;

  return visible ? (
    <StyledModal
      open={visible}
      footer={null}
      onCancel={closeModal}
      closable={false}
      destroyOnClose
      centered
      className="w-5/6 md:w-4/6"
    >
      <div className="flex flex-col items-center justify-center text-center p-0 md:p-24">
        <Image alt={t('booking.successModal.imageAlt')} src="/success-booking.svg" width={200} height={200} />
        <div className="text-5xl font-bold mt-10" style={{ color: '#404D61' }}>
          {t('booking.successModal.title')}
        </div>
        <div className="text-2xl font-bold mt-10" style={{ color: '#404D61' }}>
          {t('booking.successModal.subtitle')}
        </div>
        <a
          onClick={closeModal}
          className="flex justify-center items-center mt-10 px-20 py-3"
          style={{
            cursor: 'pointer',
            backgroundColor: 'var(--main)',
            color: 'white',
            borderRadius: '25px',
            fontSize: '20px',
            textDecoration: 'none',
          }}
          target="_blank"
          href={`https://${clientName}.pickspace.com`}
          rel="noreferrer"
        >
          {t('booking.successModal.goToLogin')}
        </a>
      </div>
    </StyledModal>
  ) : null;
};

export default SuccessModal;
